import CryptoJS from 'crypto-js';
import { getAnalytics, setUserId, setUserProperties, logEvent } from 'firebase/analytics';
import FirebaseManager from './firebaseManager';
import LogManager from './LogManager';

export default class EventManager {
  static entry: string;
  static productId: string;
  static offeringId: string;
  static productPrice: number

  get firebase () {
    return FirebaseManager.getInstance();
  }

  get analytics() {
    return getAnalytics(this.firebase);
  }

  logEvent (event: string, data: Record<string, string>) {
    const logManager = LogManager.getInstance();
    arguments[1] = processFirebaseEventParams(arguments[1]);
    logManager.log(`[FirebaseEvent] ${event}:`, data);
    logEvent(this.analytics, event, data);
  }

  logPurchaseEvent(params: Record<string, string>) {
    const data = this.stringifyValue({
      EventCategory: 'premium',
      EventLabel: 'Success',
      URL: window.location.href,
      Entry: EventManager.entry,
      ProductCurrency: 'USD',
      ...params
    });
    this.logEvent('grt_purchase_behavior', data);
  }

  setUserProperties({ uniqueId, deviceModel, isFree, groupId, role, version, buildNumber }: {
    uniqueId: string,
    deviceModel: string,
    isFree: boolean,
    groupId: string,
    role: string,
    version: string,
    buildNumber: number,
  }) {
    setUserId(this.analytics , "" + uniqueId);
    setUserProperties(
      this.analytics,
      this.stringifyValue({
        membership: isFree ? "Plus/Free" : "Premium",
        device_model: deviceModel,
        group_id: "" + groupId,
        xmpp_type: "alfred_xmpp",
        role,
        version,
        build_number: buildNumber
      })
    );
  }

  clearUserProperties() {
    setUserId(this.analytics , null);
    setUserProperties(
      this.analytics,
      this.stringifyValue({
        membership: null,
        group_id: null
      })
    );
  }

  signInPageLanded(productVersion: string) {
    const obj = this.stringifyValue({
      sign_in_page_version: productVersion,
    });
    this.logEvent("grt_signinup_landed", obj);
  }

  signInPageClickItem({ item }: { item: string }) {
    const obj = this.stringifyValue({
      item,
    });
    this.logEvent("grt_signinup_clicked", obj);
  }

  signInEmailPageLanded() {
    const obj = this.stringifyValue({
      entry: "signin",
    });
    this.logEvent("grt_signinemail_landed", obj);
  }

  signInEmailPageClick({ item }: { item: string }) {
    const obj = this.stringifyValue({
      item,
      status: "1",
    });
    this.logEvent("grt_signinemail_clicked", obj);
  }

  verifyPageLanded() {
    const obj = this.stringifyValue({
      entry: "signin",
    });
    this.logEvent("grt_verification_landed", obj);
  }

  verifyPageClick() {
    const obj = this.stringifyValue({
      item: "signin",
      status: "1",
    });
    this.logEvent("grt_verification_clicked", obj);
  }

  sendInitialLoginSucceeded({ provider, email, type = "quick" }: { provider: string, email: string, type: string }) {
    const obj = this.stringifyValue({
      provider,
      type,
      ivuu: CryptoJS.MD5(email).toString(),
    });
    this.logEvent("initial_login_succeeded", obj);
  }

  logingTime({ provider, btnclickLogin }: { provider: string, btnclickLogin: number }) {
    const obj = this.stringifyValue({
      provider,
      btnclick_login: btnclickLogin,
    });
    this.logEvent("grt_login_time", obj);
  }

  sendLoginFailed({ provider, type = "quick", code = null, customError }: { provider: string, type: string, code: string | null, customError?: string }) {
    const obj = this.stringifyValue({
      provider,
      type,
      code: "" + code,
      custom_error: customError,
    });
    this.logEvent("initial_login_failed", obj);
  }

  purchasePageLanded(entry: string) {
    EventManager.entry = entry;
    const obj = this.stringifyValue({
      EventAction: 'Landed'
    });
    this.logPurchaseEvent(obj);
  }

  purchaseStarted({ productId, offeringId, productPrice, error }: { productId: string, offeringId: string, productPrice: number, error?: { code: string, domain: string } }) {
    EventManager.productId = productId;
    EventManager.offeringId = offeringId;
    EventManager.productPrice = productPrice;

    const obj = this.stringifyValue({
      EventAction: 'Started',
      ProductId: productId,
      OfferingId: offeringId,
      productPrice,
      ErrorDomain: error?.domain || '',
      ErrorCode: error?.code || ''
    });
    this.logPurchaseEvent(obj);
  }

  purchaseCompleted(error?: { code: string; domain: string }) {
    const obj = this.stringifyValue({
      EventAction: 'Completed',
      EventLabel: error ? 'Fail' : 'Success',
      ProductId: EventManager.productId,
      OfferingId: EventManager.offeringId,
      productPrice: EventManager.productPrice,
      ErrorDomain: error?.domain || '',
      ErrorCode: error?.code || ''
    });
    this.logPurchaseEvent(obj);
  }

  purchaseVerified(error?: { code: string; domain: string }) {
    const obj = this.stringifyValue({
      EventAction: 'Verified',
      EventLabel: error ? 'Fail' : 'Success',
      ProductId: EventManager.productId,
      OfferingId: EventManager.offeringId,
      productPrice: EventManager.productPrice,
      ErrorDomain: error?.domain || '',
      ErrorCode: error?.code || ''
    });
    this.logPurchaseEvent(obj);
  }

  stringifyValue(obj: Record<string, unknown>) {
    let data = JSON.parse(JSON.stringify(obj));
    Object.keys(data).forEach((key) => {
      if (Number.isInteger(data[key])) {
        data[key] = String(data[key]);
      }
    });
    return data;
  }
}

function processFirebaseEventParams (params: Record<string, unknown>) {
  for (const key in params) {
    const value = params[key]
    if (value || value === 0) {
      const number = Number(value)
      if (!isNaN(number)) {
        params[key] = `_${value}`
      }
    }
  }
  return params
}